import { alertAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(alertAnatomy.keys);

const solid = definePartsStyle((props) => {
  if (props.status === "info") {
    return {
      container: {
        bg: "blue.800",
        color: "white",
      },
      icon: {
        color: "white",
      },
      title: {
        color: "white",
      },
      description: {
        color: "white",
      },
    };
  }
  if (props.status === "warning") {
    return {
      container: {
        bg: "orange.600",
        color: "white",
      },
      icon: {
        color: "white",
      },
    };
  }
  return {};
});

export const Alert = defineMultiStyleConfig({
  variants: { solid },
});
